import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter } from '@bibliocommons/utils-routing';
import { routerShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary, selectCurrentSite } from 'app/selectors/LibrarySelector';
import { scopeShape } from 'app/shapes/search';
import BroadenSearchButton from './BroadenSearchButton';

export class BroadenSearchButtonContainer extends React.PureComponent {
  render() {
    return <BroadenSearchButton {...this.props} />;
  }
}

BroadenSearchButtonContainer.propTypes = {
  broadenedSearchType: PropTypes.string,
  isBroadened: PropTypes.bool,
  router: routerShape,
  query: PropTypes.string,
  searchType: PropTypes.string,
  scopes: ImmutablePropTypes.listOf(scopeShape),
  library: libraryShape
};

const mapStateToProps = state => ({
  library: selectCurrentLibrary(state),
  scopes: selectCurrentSite(state).get('scopes')
});

export default withRouter(connect(mapStateToProps)(BroadenSearchButtonContainer));
